import {Component} from '@angular/core';

@Component({
    templateUrl: 'investment-application-flow.html',
    styleUrls: ['investment-application-flow.css']
})
export class InvestmentApplicationFlowComponent {
}